export default "__VITE_ASSET__DjQSW18E__"